
<style scoped lang="less">
.box {
    height: 1450px;
}
.box::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    height: 1550px;
    width: 100vw;
    background-image: url('http://static.unicornselected.com/FmwlcP8H5Q407hW3WZnnyMS99d26');
    background-size: 100% 100%;
}

.head-wrapper {
    color: white;
    .cover {
        position: relative;
        height: 370px;
        .circel {
            // background-image: url(http://static.unicornselected.com/FvWpsjBWZCCtu-05S457QV7OEyWd);
            // background-size: 100% 100%;
            position: relative;
            top: 40px;
            margin: 0 auto;
            width: 350px;
            height: 255px;

            .introduce {
                position: relative;
                top: 65px;
                .aboutOur {
                    margin: 0 auto;
                    position: relative;
                    bottom: 5px;
                    // width: 135px;

                    .aboutUs {
                        // border-bottom: 2px solid #fff;
                    }
                    > span {
                        font-size: 36px;
                    }
                }
                .text1 {
                    display: inline-block;
                    width: 300px;
                }

                .text {
                    display: inline-block;
                    .reds {
                        font-size: 16px;
                        font-weight: 500;
                        color: #bc242b;
                    }
                }

                .english {
                    font-size: 15px;
                }
            }
        }
    }
    .cover::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        height: 370px;
        width: 100vw;
        background-image: url('http://static.unicornselected.com/b45017f0-0335-11eb-91c5-d550a48abe82.jpeg');
        background-size: 100% 100%;
        filter: brightness(0.6);
    }
}
.content-wrapper {
    position: relative;
    .card {
        color: #999;
        margin: 0 auto;
        width: 600px;
        height: 250px;
        border-radius: 6px;
        top: -40px;
        box-shadow: 0px 10px 19px rgb(221, 230, 240);
        display: flex;
        flex-direction: column;
        justify-content: center;
        > img {
            margin: 0 auto;
            width: 250px;
            position: relative;
            top: -30px;
        }
        > .text1 {
            position: relative;
            top: -10px;
            margin: 0 auto;
            // width: 280px;
            // text-align: left;
            display: inline-block;
            font-size: 19px;
        }
        .en_text1 {
            padding: 0 50px;
        }
        > .text2 {
            position: relative;
            top: -10px;
            // left: 30px;
            text-align: center;
            margin: 0 auto;
            width: 300px;
            font-size: 19px;
            display: inline-block;
        }
        > .en_text2 {
            left: -25px;
        }
    }
}

.icon-right-big {
    font-size: 40px;
    border-radius: 50px;
    padding: 5px;
    background-color: rgba(208, 226, 248, 1);
}
.icon-left-big {
    font-size: 40px;
    border-radius: 50px;
    padding: 5px;
    background-color: rgba(208, 226, 248, 1);
}

.myTeam {
    position: relative;
    top: 100px;
    margin: 0 auto;
    width: 200px;
    height: 50px;
    // background-color: red;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .line {
        width: 40px;
        height: 1px;
        background-color: #999;
    }
    .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .text1 {
            font-size: 16px;
        }
        .text2 {
            font-weight: 800px;
            font-size: 12px;
            color: #999;
        }
    }
}

.lunboBtn {
    width: 50px;
}
.lunbo {
    width: 1000px;
    height: 510px;
    margin: 0 auto;
    // background-color: red;
    margin-top: 100px;
    overflow: hidden;
    overflow-x: 'hidden';
    overflow-y: 'hidden';
    position: relative;
    .lunbo-right-btn {
        position: absolute;
        top: 250px;
        left: 840px;
        display: inline-block;
    }
    .lunbo-left-btn {
        position: absolute;
        display: inline-block;
        left: 110px;
        top: 255px;
    }

    .lunbo-content-controller {
        margin: 0 auto;
        // background-color: orange;
        width: 600px;
        overflow: hidden;
        .lunbo-layout::-webkit-scrollbar {
            display: none;
        }

        .lunbo-layout {
            overflow: auto;
            height: 500px;
            width: 800px;
            overflow-x: hidden;
            overflow-y: auto;
            .lunbo-box-controller {
                margin-top: 100px;
                white-space: nowrap;
                transition: all 0.5s;
                .lunbo-box {
                    border-radius: 5px;
                    overflow: hidden;
                    width: 200px;
                    height: 250px;
                    border-radius: 5px;
                    white-space: nowrap;
                    display: inline-block;
                    transition: all 0.5s;
                    position: relative;
                    img {
                        margin: 0 auto;
                        height: 250px;
                        width: 200px;
                    }
                    .lunbo-text {
                        background: rgba(0, 0, 0, 0.192);
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        padding: 0 15px;
                        .names {
                            text-align: left;
                            color: #fff;
                            margin-top: 3px;
                        }
                        .texts {
                            color: #fff;
                            font-size: 10px;
                            text-align: left;
                            word-break: break-all;
                            white-space: nowrap;
                        }
                    }
                }
                .lunbo-active {
                    transform: scale(1.5);
                    -webkit-transform: scale(1.5) rotate(0deg);
                    -moz-transform: scale(1.5) rotate(0deg);
                    -o-transform: scale(1.5) rotate(0deg);
                    position: relative;
                    z-index: 2;
                }
                .lunbo-active .names {
                    position: relative;
                    // left: 20px;
                }
                .lunbo-active .texts {
                    transform: scale(0.76);
                    -webkit-transform: scale(0.76) rotate(0deg);
                    -moz-transform: scale(0.76) rotate(0deg);
                    -o-transform: scale(0.76) rotate(0deg);
                    position: relative;
                    left: -20px;
                }
                .lunbo-active1 {
                    position: relative;
                    z-index: 1;
                    // bottom: 30px;
                }
            }
        }
    }
}
.business-btn {
    position: relative;
    top: -50px;
    // left: 50px;
    width: 220px;
    margin: 0 auto;
    .buy-btn {
        display: inline-block;
        width: 200px;
        height: 40px;
        background: #bc242b;
        border-radius: 50px;
        span {
            color: #fff;
            line-height: 40px;
        }
    }
}
.footer {
    margin-top: 10px;
}
.ss {
    font-size: 1px;
}
</style>

<template>
    <div class="box">
        <div class="head-wrapper">
            <div class="cover">
                <div class="circel">
                    <div class="introduce">
                        <div class="aboutOur">
                            <span class="aboutUs">关于我们</span>
                            <div class="english">
                                <span class="tnr">About Us</span>
                            </div>
                        </div>
                        <!-- <div class="inline"></div> -->
                        <!-- <span class="text1">独角汇是专注于独角兽企业私募股权份额转让的信息平台</span> -->
                        <span class="text">
                            <!--  【
              <span class="reds">最完善的售后服务</span> 来确保客户满意100% 】-->
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-wrapper">
            <div class="content">
                <div class="card">
                    <img
                        src="http://static.unicornselected.com/FhIVhFpGYWRJsW-wOhxz-yF4UNcE"
                        alt
                    >
                    <template v-if='!en'>
                        <span class="text1">专注于独角兽企业私募股权份额转让的信息平台</span>
                        <span class="text2">可靠&nbsp;&nbsp;&nbsp;专业&nbsp;&nbsp;&nbsp;高效&nbsp;&nbsp;&nbsp;保密</span>
                    </template>

                    <template v-else>
                        <span class=" text1 en_text1">A pioneer information platform focusing on the transactions of unicorn private equity interests</span>
                        <span class="text2 en_text2">Reliable&nbsp;&nbsp;&nbsp;Professional&nbsp;&nbsp;&nbsp;Efficient&nbsp;&nbsp;&nbsp;Confidential</span>
                    </template>
                </div>
            </div>
        </div>
        <div class="myTeam">
            <div class="line"></div>
            <div class="text">
                <span class="text1">我们的团队</span>
                <span class="text2 tnr">OUR TEAM</span>
            </div>
            <div class="line"></div>
        </div>
        <div class="lunbo">
            <div
                class="lunbo-left-btn"
                @click="lunbo_last"
            >
                <i class="iconfont icon-left-big"></i>
            </div>
            <div class="lunbo-content-controller">
                <div class="lunbo-layout">
                    <div
                        id="lunbo"
                        class="lunbo-box-controller"
                    >
                        <div
                            class="lunbo-box smooth-shadow"
                            :class="[index==count2+1?'lunbo-active':'',index==count2+2?'lunbo-active1':'']"
                            v-for="(item, index) in register"
                            :key="index"
                            @click="moveLunbo(index)"
                        >
                            <img
                                :src=" item.img"
                                alt
                            >
                            <template v-if='!en'>
                                <div class="lunbo-text">
                                    <div class="names">{{item.name}}</div>
                                    <div class="texts">
                                        <div
                                            v-for="is of item.text"
                                            :key="is.id"
                                        >{{is}}</div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="lunbo-text">
                                    <div class="names">{{item.en_name}}</div>
                                    <div class="texts">
                                        <div
                                            v-for="is of item.en_text"
                                            :key="is.id"
                                        >{{is}}</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="lunbo-right-btn"
                @click="lunbo_next"
            >
                <i class="iconfont icon-right-big"></i>
            </div>
        </div>
        <!-- <div class="business-btn" @click="changeBushow">
      <div class="buy-btn">
        <span>查看更多</span>
      </div>
    </div>-->
        <bottom class="footer"></bottom>
        <people-detail
            ref="detail"
            @open-scroll="openScroll"
        ></people-detail>
    </div>
</template>

<script>
import Bottom from '../components/bottom';
import PeopleDetail from '../components/dialog/peopleDetail';
export default {
    components: {
        Bottom,
        PeopleDetail,
    },
    data() {
        return {
            bushow: false,
            companylist: [],
            companylist_hot: [],
            count: 0,
            countSize: 0,
            count2: 0,
            countSize2: 0,
            leftBtn: false,
            register: [
                {
                    img: 'http://static.unicornselected.com/b136f110-0335-11eb-91c5-d550a48abe82.png',
                    name: '王琰',
                    en_name: 'Yan Wang',
                    text: [
                        '独角汇联合创始人',
                        '北京大学经济学学士',
                        '美国罗切斯特大学金融硕士',
                    ],
                    en_text: [
                        'Co-founder',
                        'BEc, Peking University',
                        'MS in Finance, University of Rochester',
                    ],
                },
                {
                    img: 'http://static.unicornselected.com/b1630a20-0335-11eb-91c5-d550a48abe82.jpeg',
                    name: '邱昉',
                    en_name: 'Robert Qiu',
                    text: [
                        '独角汇创始合伙人、董事长',
                        '北京大学经济学学士',
                        '密歇根大学金融工程硕士、CFA、FRM',
                    ],
                    en_text: [
                        'Founder & CEO',
                        'BEc, Peking University',
                        'MFE, University of Michigan',
                        'CFA、FRM',
                    ],
                },
                {
                    img: 'http://static.unicornselected.com/b1995c60-0335-11eb-91c5-d550a48abe82.png',
                    name: '肖建学',
                    en_name: 'Jianxue Xiao',
                    text: ['独角汇联合创始人', '北京大学工商管理硕士'],
                    en_text: ['Co-founder', 'MBA', 'Peking University'],
                },
                {
                    img: 'http://static.unicornselected.com/b24aab00-0335-11eb-91c5-d550a48abe82.png',
                    name: '杨培琴',
                    en_name: ' Peiqin Yang',

                    text: [
                        '独角汇联合创始人',
                        '清华大学经济管理学院硕士',
                        '中国注册会计师、加拿大注册会计师',
                    ],
                    en_text: [
                        'Co-founder',
                        'Master, Tsinghua SEM',
                        'CPA, CPA Canada',
                    ],
                },
            ],
            cardIndex: 1,
        };
    },

    methods: {
        changeBushow() {
            this.$refs.detail.cardIndex = this.cardIndex;
            this.$refs.detail.show = true;
        },

        lunbo_last() {
            let hot = document.getElementById('lunbo');
            if (this.count2 == -1) {
                this.leftBtn = false;
            }
            if (this.count2 <= -1) {
                return;
            }
            this.count2--;
            let count2 = -200 * this.count2;
            hot.style.transform = `translateX(${count2}px)`;

            this.cardIndex = this.count2 + 1;
        },
        lunbo_next() {
            let hot = document.getElementById('lunbo');

            if (this.count2 == 2) {
                return;
            }
            this.count2++;
            let count2 = -200 * this.count2;
            hot.style.transform = `translateX(${count2}px)`;
            this.leftBtn = true;

            this.cardIndex = this.count2 + 1;
        },
        fetch() {
            this.fetchList();
            this.fetchHot();
        },
        pushTo() {
            this.$router.push('/companylist');
        },
        moveLunbo(index) {
            //   现在中间的数
            let mediumBtn = this.count2 + 1;

            this.cardIndex = index;
            if (index - 1 == mediumBtn) {
                let hot = document.getElementById('lunbo');

                if (this.count2 == 4) {
                    return;
                }
                this.count2++;
                let count2 = -200 * this.count2;
                hot.style.transform = `translateX(${count2}px)`;
                this.leftBtn = true;
            }
            if (index + 1 == mediumBtn) {
                let hot = document.getElementById('lunbo');
                if (this.count2 == -1) {
                    this.leftBtn = false;
                }
                if (this.count2 <= -1) {
                    return;
                }
                this.count2--;
                let count2 = -200 * this.count2;
                hot.style.transform = `translateX(${count2}px)`;
            }
            document.body.style.height = '100vh';
            document.body.style.overflow = 'hidden';
            setTimeout(() => {
                if (index == this.count2 + 1) {
                    this.$refs.detail.cardIndex = this.cardIndex;
                    this.$refs.detail.show = true;
                }
            }, 500);
        },
        openScroll() {
            document.body.style.height = 'auto';
            document.body.style.overflow = 'auto';
        },
    },
};
</script>
